import { render, staticRenderFns } from "./payment-result-card.vue?vue&type=template&id=30b5a62e&scoped=true&"
import script from "./payment-result-card.vue?vue&type=script&lang=ts&"
export * from "./payment-result-card.vue?vue&type=script&lang=ts&"
import style0 from "./payment-result-card.vue?vue&type=style&index=0&id=30b5a62e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b5a62e",
  null
  
)

export default component.exports